import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import keycloak from '../keycloak/keycloak';

const EditAccount = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (keycloak.authenticated) {
      const accountUrl = `${keycloak.authServerUrl}/realms/${keycloak.realm}/account/?referrer=${keycloak.clientId}&referrer_uri=${window.location.origin}`;
      
      window.open(accountUrl, '_blank'); 

      navigate('/user-profile'); 
    } else {
      navigate('/');
    }
  }, [navigate]);

  return <div>Redirecting to Keycloak account management...</div>;
};

export default EditAccount;

